import React from 'react';
import { Field } from '@atlaskit/form';
import AddIcon from '@atlaskit/icon/glyph/add';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import Button from '@atlaskit/button';
import { AddOn } from '@css-xp/graphtypes';
import './statuspage-available-add-ons-form-field-v2.scss';
import TextField from '@atlaskit/textfield';

interface Props {
  availableAddOns: AddOnOption[];
  selectedAddOns: AddOnOption[];
  removeAddOn: (index: number) => void;
  addAdditionalAddOn: () => void;
  updateSelectedAddOn: (addOn: AddOnOption, index: number) => void;
  updateSelectedAddOnQuantity: (units: number, index: number) => void;
}

export interface AddOnSelectItem {
  label: AddOnOption['name'];
  value: {
    offeringId: AddOnOption['offeringId'];
  };
}

export type AddOnOption = Pick<AddOn, 'name' | 'offeringId' | 'units'>;

const StatuspageAvailableAddOnsFormFieldV2 = ({
  availableAddOns,
  selectedAddOns,
  removeAddOn,
  addAdditionalAddOn,
  updateSelectedAddOn,
  updateSelectedAddOnQuantity,
}: Props) => {
  return (
    <div className="selected-add-on-container">
      {selectedAddOns.map((addOn, index) => {
        return (
          <div className="selected-add-on" key={`selected-add-on-${index}`} data-testid={`selected-add-on-${index}`}>
            <div className="add-on-dropdown" data-testid="add-on-dropdown">
              <Field name={`selectedAddOns[${index}].selectedAddOn`} label={'Select additional allocation'} isRequired>
                {({ fieldProps }) => (
                  <DropdownMenu
                    {...fieldProps}
                    testId={`selected-add-on-${index}-dropdown`}
                    trigger={addOn?.name ?? 'None'}
                    position="bottom left"
                    triggerType="button"
                    triggerButtonProps={{
                      className: 'selected-add-on-dropdown-btn',
                    }}
                  >
                    <DropdownItemGroup>
                      {availableAddOns.map((item) => {
                        return (
                          <DropdownItem
                            key={item.offeringId}
                            onClick={() =>
                              updateSelectedAddOn(
                                {
                                  ...item,
                                  units: addOn?.units ?? item.units,
                                },
                                index
                              )
                            }
                          >
                            {item.name}
                          </DropdownItem>
                        );
                      })}
                    </DropdownItemGroup>
                  </DropdownMenu>
                )}
              </Field>
            </div>
            <div className="quantity-dropdown">
              <Field name={`selectedAddOns[${index}].quantity`} label="Quantity">
                {({ fieldProps }) => (
                  <TextField
                    {...fieldProps}
                    type="number"
                    min="1"
                    max="100"
                    testId="quantity-addons"
                    onChange={(e: any) => {
                      fieldProps.onChange(e.target.value);
                      updateSelectedAddOnQuantity(e.target.value, index);
                    }}
                  />
                )}
              </Field>
            </div>
            {selectedAddOns?.length > 1 && (
              <div className="remove-button">
                <Button appearance="link" testId={`remove-add-on-${index}`} onClick={() => removeAddOn(index)}>
                  Remove
                </Button>
              </div>
            )}
          </div>
        );
      })}
      <div>
        <Button
          iconBefore={<AddIcon label="Subscribe to another add-on" />}
          appearance="link"
          testId="subscribe-another-add-on"
          onClick={() => addAdditionalAddOn()}
        >
          Subscribe to another additional allocation
        </Button>
      </div>
    </div>
  );
};

export default StatuspageAvailableAddOnsFormFieldV2;
